<template>
  <div class="page">
    <initio-panel :hide-submit="true" @submit-handler="submitHandler" :errors="errors">
      <template v-slot:title>
        <h1>Make Payment</h1>
      </template>
      <template v-slot:before_form>

        <div class="info box" v-if="getChangelist() && (getChangelist().length !== 0)">
          <h3 class="title is-4 has-text-weight-normal">Here's what we are changing</h3>
          <div class="content">
            <ul>
              <li :key="question.name" v-for="question in getChangelist()">{{ question.name }} changed from <span class="old has-text-weight-bold">{{ question.before }}</span> to <span class="new has-text-weight-bold">{{ question.after }}</span></li>
            </ul>
          </div>
        </div>

        <CoverDetails></CoverDetails>
        <MainDriverDetails></MainDriverDetails>
        
        <div class="box" v-if="answers[getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw != 0 || ( getChangelist() && getChangelist().length !== 0)">
          <div class="columns">
            <div class="column">
              <h3 class="title is-4">{{ paymentInterval(true) }} payment</h3>
            </div>
            <div class="column">
              <div class="is-flex is-justify-content-flex-end">
                <router-link :to="{ name: 'VehicleRenew.Quote'}">
                  <span v-if="paymentInterval() == 'monthly'">Change to yearly payment</span><span v-else>Change to monthly payment</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="mb-3" v-if="paymentInterval() == 'monthly'">
            <strong>Credit or debit cards payments only</strong>, we are unable to provide monthly payments via direct debit, automatic or manual payments. Future payments will automatically be deducted from the registered card, the card details can be updated at any time from your account.
          </div>
          <StripePayment v-if="paymentInterval() == 'monthly'" v-on:success-response-data="setResponseParamsAndRedirectToSuccessPage" />
          <template v-if="paymentInterval() == 'yearly'">
            <AnnualPayment />
          </template>
        </div>

        <div class="next-billing-cycle-info">
          <strong><template v-if="paymentInterval() == 'monthly'">Credit card </template><template v-else>Your payment method </template>will be charged today</strong> for cover starting from <strong>{{ renewalStartDate }}</strong>.
          <div v-if="paymentInterval() == 'monthly' && next_period_total_cost_inc_gst">Cover will <strong>automatically renew each month</strong> and your next payment will be <strong>{{ next_period_total_cost_inc_gst | toCurrency }}</strong> charged on <strong>{{ fulltextDate(next_period_billing_date_sql) }}</strong>.</div>
          You will be instantly emailed your policy documentation, including your invoice.
        </div>

      </template>
      <template v-slot:sidebar>
        <initio-summary-payment class="info-box" />
        <disclosure-block />
      </template>
    </initio-panel>
  </div>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioSummaryPayment from '@/components/partials/SummaryPayment.vue'
import StripePayment from '@/components/partials/StripePayment.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import { mapGetters } from 'vuex'
import { fulltextDate } from '@/helpers/dateHelper.js'
import { toCurrency } from '@/helpers/currencyHelper.js'
import AnnualPayment from '@/components/partials/AnnualPayment.vue'
import store from "../../../store/store";
import DisclosureBlock from "../../partials/DisclosureBlock";
import CoverDetails from '@/components/partials/CoverDetails';
import MainDriverDetails from '@/components/partials/MainDriverDetails'
import { api } from '@/store/store.js'
const axios = require("axios");

export default {
  components: {
    DisclosureBlock,
    InitioPanel,
    InitioSummaryPayment,
    AnnualPayment,
    StripePayment,
    CoverDetails,
    MainDriverDetails
  },
  mixins: [
    stepSubmit
  ],
  created () {
      this.$store.commit('updateSchema', []); // clear previous schema, as no schema for this page
  },
  mounted () {

      // we can check that we have data ready to go
      // this is at the start because it results in an axios call which will fail
      // then is caught by the axios interceptor and will redirect to error page
      // Store from previous quote-page ajax response to vue state

      const selected_driver = this.answers[this.getStep('Vehicle.Confirm')].vehicle_confirm_driver;

      if( this.client.drivers.find(element => element.driver_id === parseInt(selected_driver) )  ) {
        const existing_driver = this.client.drivers.find(element => element.driver_id === parseInt(selected_driver) ); // how do I stop the repeated question
        this.drivers_details = [
          { title: "Name of main driver", value: `${existing_driver.first_name} ${existing_driver.last_name}` },
          { title: "Birthdate", value: fulltextDate(existing_driver.dob) }
        ];
      }

      // Only fetch next period data for monthly payments
      if (this.paymentInterval() === 'monthly') {
        this.getNextPeriodData();
      }

  },
  methods: {
    toCurrency,
    fulltextDate,
    submitHandler() {
      let context = this;

      this.genericSubmitHandler()
        .then(response => {
          // console.log(response)
        }, error => {
          console.error("VehiclePayment Handler error", error); // Unsure if we need this or not, remove if not needed
          context.errors = error;
        });
    },
    toggleModal: function () {
        this.modalOpen = ! this.modalOpen;
    },
    getChangelist() {
      return this.$store.state.sessions[this.$store.state.session_id].backendData.changelist;
    },
    back: function() {
      this.currentSession.stepPath.pop();
      this.$router.push({name: this.currentSession.stepPath.slice(-1)[0] });
      //this.$router.go(-1);
    },
    setResponseParamsAndRedirectToSuccessPage(success_data){
      // Ideally we should be going through standard submit instead of manually adding data here
      let successPage = "VehicleRenew.Success";

      store.commit(
          'updateBackendData',
          {"VehicleRenew.Success": success_data}
      );
      store.getters.currentSession.stepPath.push(successPage);

      setTimeout(() => {
        // route to next page
        this.$router.push({name: successPage });
        // scroll to top
        window.scrollTo(0,0);
      }, 600); // Give some time to show a success message
    },

    getNextPeriodData() {

        this.errors = [];
        this.next_period_total_cost_inc_gst = null;
        this.next_period_billing_date_sql = null;

        axios.post(`${api.url + api.version}vehicle/new/next-period-premium/${this.sessionId()}`)
            .then(response => {

              if (response.data.results && response.data.results.total_cost_inc_gst && response.data.results.next_billing_date_sql ) {
                const results = response.data.results;
                this.next_period_total_cost_inc_gst = results.total_cost_inc_gst;
                this.next_period_billing_date_sql = results.next_billing_date_sql;

              } else {
                console.error("Problem confirming next billing cycle for vehicle", response.data);
                this.errors.push('Problem confirming next billing cycle. Please go back and try again.');
              }

            }, error => {

              console.error("Problem confirming next billing cycle. Please go back and try again.");
              this.errors.push('Problem confirming next billing cycle. Please go back and try again.');
            });
        },

  },
  computed: {
    ...mapGetters({
      answers: 'flattenedAnswers',
      answerLabel: 'getAnswerLabel',
      getAnswer: 'getAnswer',
      sessionId: 'getSessionId',
      client: 'client',
      getStep: 'getStep',
      isAltFlow: 'isAltFlow',
      currentSession: 'currentSession',
      paymentInterval: 'getPaymentInterval',
    }),

    renewalStartDate() {
      // Renewal start date is stored in computed_effective_date_sql (the expiry date of the old policy)
      // Check in backendData (private storage from backend)
      const backendData = this.$store.state.sessions[this.sessionId()]?.backendData;
      const effectiveDate = backendData?.VehicleRenew?.computed_effective_date_sql
        || backendData?.computed_effective_date_sql;

      return effectiveDate ? this.fulltextDate(effectiveDate) : '';
    }
  },
  data () {
    return {
      errors: [],
      cover_details: [],
      drivers_details: [],
      next_period_total_cost_inc_gst: null,
      next_period_billing_date_sql: null,
      modalOpen: false
    }
  }
}

</script>

<style scoped lang="scss">
  @import '~@/scss/partials/icons.scss';

  ::v-deep {
    .button {
      &--feature {
        padding: 0.1rem 0.4rem;
        height: auto;
        line-height: 0.8rem;
        vertical-align: middle;
        margin-top: -0.15rem;
        display: inline-block;
        margin-left: 0.4rem;
        pointer-events: none;

        &.is-primary {
          background: none;
          border: 1px solid $initio-green;
          color: $initio-green;
        }
        &.is-danger {
          background: none;
          border: 1px solid $red;
          color: $red;
        }
      }
    }

    div.column > .formulate-input-element {
      margin: 0;
      padding: 0;
    }

    .chosen-vehicle-block {
      padding: 0;
      background: none;
      border: none;
    }
  }

  .next-billing-cycle-info {
    font-size: 14px;
    color: $grey-text;
    strong {
      color: $grey-text;
    }
  }

  .box.info {
    background:$info-blue;
    border:none;
    font-size:(14rem / 16);

    ul {

      li {
        padding-left:0.3rem;

        &::before {
          content:"\2022";
          position:absolute;
          left:-1rem;
          font-size:1.2rem;
        }
      }
    }
  }

  .new {
    color:$initio-green;
  }
  .old {
    color:$red;
  }

  .next-billing-cycle-info {
    font-size: 14px;
    color: $grey-text;
    strong {
      color: $grey-text;
    }
  }

</style>